import { Component } from '@angular/core';

@Component({
  selector: 'app-free-zones',
  templateUrl: './free-zones.component.html',
  styleUrl: './free-zones.component.scss'
})
export class FreeZonesComponent {

}
